import './bootstrap';
import './scrollappear';
import Quill from 'quill';
import BlogEntity from './html/blog/BlogEntity.js';
import BlogPreview from './html/blog/BlogPreview.js';
import BlogItemEntity from './html/blog/BlogItemEntity.js';
import BlogList from './html/blog/BlogList.js';
import CategoryList from './html/blog/CategoryList.js';
import UserList from './html/blog/UserList.js';
import PhotoManager from './html/photo/PhotoManager.js';
import { Element, Entity, Button } from '@chaysehartsuff/active-html';

window.Entity = Entity;
window.BlogEntity = BlogEntity;
window.BlogItemEntity = BlogItemEntity;
window.BlogPreview = BlogPreview;
window.BlogList = BlogList;
window.CategoryList = CategoryList;
window.UserList = UserList;
window.PhotoManager = PhotoManager;
window.ElementComponent = Element;
window.Button = Button;
window.Quill = Quill;